export const dossiersConstants = {
    DOSSIERS_LOADING: 'DOSSIERS_LOADING',
    GETDOSSIERS_SUCCESS: 'GET_DOSSIERS_SUCCESS',
    GETDOSSIERS_FAILURE: 'GET_DOSSIERS_FAILURE',
}
